import { useEffect, useState } from "react";

export const useEmbed = () => {
  const [isEmbedded, setisEmbedded] = useState(false);

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    setisEmbedded(urlParams.get("mode") === "embed");
  }, []);

  return isEmbedded;
};
